import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
// import "./assets/styles.css";
import "./assets/styles2.css";
import "./assets/animation.css";
import "./assets/responsive.css";
import "./assets/variables.css";
import { ModalProvider } from './context/ModalContext.jsx';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";



ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ModalProvider>
      <App />
    </ModalProvider>
  </React.StrictMode>,
)
